var TextAlignment;
(function (TextAlignment) {
    TextAlignment["CENTER"] = "center";
    TextAlignment["INITIAL"] = "initial";
    TextAlignment["JUSTIFY"] = "justify";
    TextAlignment["LEFT"] = "left";
    TextAlignment["RIGHT"] = "right";
})(TextAlignment || (TextAlignment = {}));
export default TextAlignment;
//# sourceMappingURL=text-alignment.js.map